import { useEffect } from 'react';
import SEOHead from '@/components/base/SEOHead';
import BreadcrumbNav from '@/components/base/BreadcrumbNav';
import { siteConfig } from '@/mocks/home';
import { Link } from 'react-router-dom';

const teamMembers = [
  { name: '张天宇', role: '制作人', desc: '十年MMORPG研发经验，征途系列核心制作人' },
  { name: '李明远', role: '技术总监', desc: '前腾讯高级工程师，专注游戏引擎优化' },
  { name: '陈思涵', role: '美术总监', desc: '国风美术大师，多款经典游戏视觉设计' },
  { name: '王子轩', role: '运营总监', desc: '资深游戏运营专家，千万用户级产品经验' },
];

const testimonials = [
  {
    name: '老玩家·龙战天下',
    avatar: 'D',
    rating: 5,
    text: '从端游时代就开始玩征途了，手游版完美还原了当年的感觉。国战还是那么热血，兄弟帮会还在身边，每天不上去砍两把就手痒！',
    date: '2026-08-08',
  },
  {
    name: '新玩家·月影清风',
    avatar: 'Y',
    rating: 5,
    text: '朋友推荐入坑的，一开始担心手游操作不方便，玩了两天就完全上手了。画面惊艳，玩法丰富，完全超出预期！已经充了两个月的月卡了。',
    date: '2026-08-06',
  },
  {
    name: '资深玩家·铁血战魂',
    avatar: 'T',
    rating: 5,
    text: '玩了将近三年，见证了这个游戏的不断进步。每次更新都有惊喜，运营团队很用心。国战系统永远的神，其他游戏根本比不了！',
    date: '2026-08-03',
  },
  {
    name: '回归玩家·江湖故人',
    avatar: 'J',
    rating: 4,
    text: 'A了半年又回来了，变化真的很大！新版本多了好多玩法，福利也比以前好了。唯一建议是希望优化一下低端机的适配，其他都很满意。',
    date: '2026-08-01',
  },
  {
    name: '帮主·纵横四海',
    avatar: 'Z',
    rating: 5,
    text: '带着帮会从开服一直玩到现在，经历过辉煌也经历过低谷。征途最吸引我的就是兄弟情义，帮会联赛和国战让我们真正体会到了什么叫并肩作战。',
    date: '2026-07-28',
  },
  {
    name: '休闲玩家·云淡风轻',
    avatar: 'Y',
    rating: 4,
    text: '不追求太高战力，每天上线做做日常、聊聊天就挺开心的。游戏氛围很好，结交了不少朋友。交易的自由度也很高，小白也能玩得很舒服。',
    date: '2026-07-25',
  },
];

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <SEOHead
        title="关于征途国际 - 品牌介绍、用户口碑与联系方式 | 征途国际官方下载"
        description="征途国际品牌介绍：经典征途IP焕新升级，五千万玩家的热血选择。查看用户真实口碑评价，了解征途国际手游的品牌故事与联系方式。"
        keywords="征途国际品牌,征途国际介绍,征途国际口碑,征途国际联系方式,征途国际客服"
        canonicalUrl="https://hspew.cn/about"
      />

      <div className="pt-24 pb-16 md:pb-24 bg-background-50">
        <div className="mx-auto px-4 md:px-6 max-w-7xl">
          <div className="mb-6">
            <BreadcrumbNav
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          {/* Brand Introduction */}
          <section className="mb-16 md:mb-24">
            <div className="max-w-3xl">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
                品牌介绍
              </span>
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                关于{siteConfig.name}
              </h1>

              <div className="relative rounded-2xl overflow-hidden mb-8 h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20palace%20with%20golden%20rooftops%20at%20sunset%2C%20epic%20scale%2C%20warm%20crimson%20and%20amber%20lighting%2C%20cinematic%20game%20art%2C%20atmospheric%20clouds%2C%20heroic%20fantasy%20landscape%2C%20magestic%20composition&width=1600&height=900&seq=about-hero-01&orientation=landscape"
                  alt="征途国际品牌"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="space-y-4 text-foreground-700 leading-relaxed text-sm md:text-base">
                <p>
                  <strong>{siteConfig.name}</strong>是经典征途IP的正版手游续作，由资深研发团队倾力打造。
                  传承端游经典的国战玩法与兄弟情义精神，融合移动端便捷操作体验，
                  为五千万玩家呈现了一个热血、真实、充满家国情怀的古代战争世界。
                </p>
                <p>
                  自上线以来，征途国际始终坚持<strong>公平竞技、玩家至上</strong>的理念，
                  不断优化游戏体验，推出丰富的新内容。从最初的经典国战模式，
                  到如今的跨服竞技、帮会联赛、装备觉醒等多维度玩法，
                  征途国际已经成为国产MMORPG手游的标杆之作。
                </p>
                <p>
                  我们的愿景是打造<strong>全球最热血的手游社区</strong>。
                  在这里，你不仅能体验到万人国战的激情，更能结识来自天南地北的兄弟，
                  一起并肩作战、共闯征途。无论你是追求战力巅峰的硬核玩家，
                  还是享受社交乐趣的休闲玩家，征途国际都有属于你的一片天地。
                </p>
              </div>
            </div>
          </section>

          {/* Team Members */}
          <section className="mb-16 md:mb-24">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
                核心团队
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                匠心打造，只为精品
              </h2>
              <p className="text-foreground-600 text-sm max-w-xl mx-auto">
                来自行业顶尖厂商的资深团队，用热爱与专业打造征途国际
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {teamMembers.map((member) => (
                <div key={member.name} className="p-6 rounded-2xl bg-background-100 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-accent-500 flex items-center justify-center text-xl font-bold text-background-50">
                    {member.name.charAt(0)}
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-1">{member.name}</h3>
                  <p className="text-xs text-accent-600 font-medium mb-2">{member.role}</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">{member.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Reputation / Testimonials */}
          <section className="mb-16 md:mb-24">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
                用户口碑
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                玩家真实评价
              </h2>
              <p className="text-foreground-600 text-sm max-w-xl mx-auto">
                来自五千万玩家的真实声音，是我们前进的最大动力
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="p-5 rounded-2xl bg-background-100">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center text-sm font-bold text-background-50 flex-shrink-0">
                      {t.avatar}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: t.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
                  <p className="text-xs text-foreground-400 mt-3">{t.date}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact Information */}
          <section>
            <div className="max-w-3xl">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
                联系我们
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                联系{siteConfig.name}
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
                <div className="p-5 rounded-2xl bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服热线</h3>
                    <p className="text-sm text-foreground-600">400-888-8888</p>
                    <p className="text-xs text-foreground-400 mt-0.5">服务时间：每日 9:00 - 21:00</p>
                  </div>
                </div>

                <div className="p-5 rounded-2xl bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">官方邮箱</h3>
                    <p className="text-sm text-foreground-600">support@hspew.cn</p>
                    <p className="text-xs text-foreground-400 mt-0.5">一般24小时内回复</p>
                  </div>
                </div>

                <div className="p-5 rounded-2xl bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">官方微信</h3>
                    <p className="text-sm text-foreground-600">征途国际手游</p>
                    <p className="text-xs text-foreground-400 mt-0.5">关注获取最新活动资讯</p>
                  </div>
                </div>

                <div className="p-5 rounded-2xl bg-background-100 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-600">上海市浦东新区张江高科技园区征途大厦</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-2xl bg-background-100">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  如果您对{siteConfig.name}有任何建议或意见，欢迎通过以上方式联系我们。
                  我们珍视每一位玩家的反馈，并将持续努力为您带来更好的游戏体验。
                  如遇到游戏内问题，也可以通过游戏内的<Link to="/about" className="text-primary-600 hover:text-primary-700 font-medium">客服系统</Link>提交工单，
                  我们将尽快为您处理。
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}